import { createNewGuid } from 'Utils/uuid';

const getFileName = (headers: unknown): string => {
	if (typeof headers !== 'object') return createNewGuid();
	const contentDisposition = (headers as Record<string, unknown>)?.['content-disposition'];
	if (typeof contentDisposition !== 'string') return createNewGuid();

	const filenameMatch = contentDisposition.match(/(?<=filename=)[^;]+/);
	const finalName = filenameMatch?.[0] ?? createNewGuid();
	return finalName.replaceAll('"', '');
};

const createLinkElementAndSetAttributes = (blob: Blob, headers: unknown): HTMLAnchorElement => {
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.type = 'hidden';
	link.download = getFileName(headers);
	return link;
};

const downloadBlob = (blob: Blob, headers: unknown): void => {
	const link = createLinkElementAndSetAttributes(blob, headers);
	document.body.appendChild(link);
	link.click();
	link.remove();
};

export default downloadBlob;
